export default {
  title: "特例適用一覧",
  listHeader: {
    tripId: "TripID",
    division: "区分",
    startTime: "開始時間",
    endTime: "終了時間",
    numberPlate: "車番",
    driverName: "ドライバー",
    edit: "詳細・編集",
    updatedByAndDate: "最終更新者/日付",
  },
  unexpectedEvents: "予期し得ない事象",
  longTimeContinuousDriving: "連続運転時間超過の延長",
  filter: {
    selectDivision: {
      title: "区分",
      all: "全て",
      unexpectedEvent: "予期し得ない事象",
      longTimeContinuousDriving: "連続運転時間超過",
    },
    radioButton: {
      startTime: "開始時間",
      endTime: "終了時間",
    }
  },
  deleteModal: {
    longTimeContinuousDrivingExtension: {
      note: "選択した連続運転時間超過の延長を削除します。",
    },
    unexpectedEvent: {
      note: "選択した予期し得ない事象の登録を削除します。",
    },
  },
  fileDownload: {
    notExistsFilePath: "不正なファイルパスです。"
  }
}
